import {connect} from 'react-redux';
import ProductListComponent from "./List/ProductList";
import {CreateProduct} from "./Create/CreateProduct";
import {actions} from '../../js/redux/products/products';
import {CreateCategoriesConn, CategoriesListConn} from "./Categories"

const productState = (state) => {
  return {
    ...state.product,
  };
};


const CreateProductConn = connect(productState, actions)(CreateProduct);
const ProductsListConn = connect(productState, actions)(ProductListComponent);

export {
  CreateProductConn,
  ProductsListConn,
  CreateCategoriesConn,
  CategoriesListConn,
}